module.exports = __webpack_public_path__ + "static/media/4.12_preview.acd8ddc0.png";